import { useApplicationSteps } from '../pages/dashboard/loan_detail/ApplicationStepsContext';
import { getCurrentFlow } from '../pages/dashboard/loan_detail/flows';
import { APPLICATION_FLOW_TYPE } from '../pages/dashboard/loan_detail/flows/constants';

export const useCurrentFlow = () => {
  const { data } = useApplicationSteps();
  if (!data) return APPLICATION_FLOW_TYPE.MAIN;
  return getCurrentFlow(data.application);
};
